/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Class_Datetimeaftertodayaspect13Inputs */

const de__class_datetimeaftertodayaspect13 = /** @type {(inputs: _Class_Datetimeaftertodayaspect13Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`nach heute relativ`)
};

/**

* @param {_Class_Datetimeaftertodayaspect13Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _class_datetimeaftertodayaspect13 = /** @type {((inputs?: _Class_Datetimeaftertodayaspect13Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Class_Datetimeaftertodayaspect13Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__class_datetimeaftertodayaspect13(inputs)
});
export { _class_datetimeaftertodayaspect13 as "_class_DateTimeAFTERTODAYAspect" }